import React, { useEffect, useState } from "react";
import { Container, Modal } from "reactstrap";
import { useMemo } from "react";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
} from "reactstrap";
import Loader from "pages/Separate/Loader";
import AccessDeniedPopup from "routes/AccessDeniedPopup";
import NewPagination from "components/Common/Newpagination";
import "../../../../assets/css/Work/support.css";
import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";
import secureLocalStorage from "react-secure-storage";
import {
  fetchData,
  fetchNodeData,
  FetchNodePostData,
  FetchPostData,
} from "utils/common-fetchData";
import ReplyIndex from "../Tickets/Reply/ReplyIndex";
import { developerTicketColumn } from "utils/columns/Support/developerTicketColumns";
import Swal from "sweetalert2";
import Select from "react-select";
import NoTickets from "../../../../assets/images/Inventory/warningImg.jpg";
import { useTimer } from "pages/WorkModule/Projects/Project Timer/TimerContext";
import {
  calculateTimeDifference,
  calculateTotalTaskTime,
} from "utils/common-helpers";
import viewTaskImg from "../../../../assets/images/Project/viewTask.jpg";
import moment from "moment";
import { resaonOtption } from "utils/common-options";

function TableContainer({ columns, data, setData, allData, onStatus }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: "id", // Set the ID of the first column for default sorting
            desc: true, // `true` for descending, `false` for ascending
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  const { pageIndex, pageSize, globalFilter } = state;
  useEffect(() => setPageSize(50), []);
  const [isLoading, setLoading] = useState(false);
  const [status, setStatus] = useState("all");

  return (
    <div>
      {isLoading && <Loader />}
      <div id="support-header" className="mb-4 align-items-center row">
        <div className="pr-0 support-status-part general-status-part col-md-10">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex justify-content-start w-100 text-center align-items-center gap-3">
              <a
                className={`text-green pt-2 px-0 rounded work-status general-task-status ${
                  status == "all" ? "activeProjectTab" : ""
                }`}
                onClick={() => {
                  setStatus("all");
                  onStatus("all");
                  setData(allData);
                }}
              >
                <h4>{allData?.length}</h4>
                <h4>All</h4>
              </a>
              <a
                className={`text-green pt-2 px-0 rounded work-status general-task-status ${
                  status == "not" ? "activeProjectTab" : ""
                }`}
                onClick={() => {
                  setStatus("not");
                  onStatus(0);
                  setData(allData?.filter((obj) => obj?.status == 0));
                }}
              >
                <h4>{allData?.filter((obj) => obj?.status == 0)?.length}</h4>
                <h4>Not Answered</h4>
              </a>
              <a
                className={`text-green pt-2 px-2 rounded work-status general-task-status ${
                  status == "answered" ? "activeProjectTab" : ""
                }`}
                onClick={() => {
                  setStatus("answered");
                  onStatus(3);
                  setData(allData?.filter((obj) => obj?.status == 3));
                }}
              >
                <h4>{allData?.filter((obj) => obj?.status == 3)?.length}</h4>
                <h4>Answered</h4>
              </a>
              <a
                className={`text-green pt-2 px-2 rounded work-status general-task-status ${
                  status == "hold" ? "activeProjectTab" : ""
                }`}
                onClick={() => {
                  setStatus("hold");
                  onStatus(4);
                  setData(allData?.filter((obj) => obj?.status == 4));
                }}
              >
                <h4>{allData?.filter((obj) => obj?.status == 4)?.length}</h4>
                <h4>On Hold</h4>
              </a>
              <a
                className={`text-green pt-2 px-2 rounded work-status general-task-status ${
                  status == "finish" ? "activeProjectTab" : ""
                }`}
                onClick={() => {
                  setStatus("finish");
                  onStatus(5);
                  setData(allData?.filter((obj) => obj?.status == 5));
                }}
              >
                <h4>{allData?.filter((obj) => obj?.status == 5)?.length}</h4>
                <h4>Closed</h4>
              </a>
              <a
                className={`text-green pt-2 px-2 rounded work-status general-task-status ${
                  status == "query" ? "activeProjectTab" : ""
                }`}
                onClick={() => {
                  setStatus("query");
                  onStatus(6);
                  setData(allData?.filter((obj) => obj?.status == 6));
                }}
              >
                <h4>{allData?.filter((obj) => obj?.status == 6)?.length}</h4>
                <h4>Queries</h4>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Row>
        <div className="col-md-12 my-4 d-flex">
          <div className="col-md-6 d-flex justify-content-start align-items-center">
            <div className="col-md-2 d-flex justify-content-start align-items-center">
              <select
                className="s me-4 form-select"
                style={{ width: "100px" }}
                value={pageSize}
                onChange={(e) => setPageSize(e.target.value)}
              >
                {[10, 25, 50, 100].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-md-6 d-flex justify-content-end align-items-center">
            <div className="search-box">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="s form-control rounded "
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </Row>

      <div className="position-relative">
        <Table className="table table-bordered" {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => {
                  const classNames = column.className;
                  return (
                    <th
                      key={index}
                      className={`col-t-${index + 1} ${classNames} ${
                        index != 0 && "customShortIcon"
                      }`}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      <div>
                        {column.render("Header")}
                        {column.isShortIcon ? (
                          <span
                            style={{
                              display: index == 0 ? "none" : "block",
                            }}
                            onClick={() =>
                              column.getSortByToggleProps().onClick()
                            }
                          >
                            <i
                              title="Ascending"
                              className={`bi bi-arrow-up ms-1 info-icon ${
                                column.isSorted && !column.isSortedDesc
                                  ? "text-dark"
                                  : ""
                              }`}
                            ></i>
                            <i
                              title="Descending"
                              className={`bi bi-arrow-down info-icon ${
                                column.isSorted && column.isSortedDesc
                                  ? "text-dark"
                                  : ""
                              }`}
                            ></i>
                          </span>
                        ) : null}
                      </div>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody className="fix-support-table-body" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              let backgroundStyle = {};
              const priority = row.original.priority_col;

              return (
                <tr {...row.getRowProps()} key={i} style={backgroundStyle}>
                  {row.cells.map((cell, index) => (
                    <td
                      key={index}
                      className={`t-col-${index + 1} ${cell.column.className} ${
                        priority == "High" ? "highPriority" : ""
                      }`}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPag={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>
    </div>
  );
}

const DeveloperTickets = ({ projectOption }) => {
  const [replyTiket, setReplyTiket] = useState(false);
  const [viewTicketHistory, setViewTicketHistory] = useState(false);
  const [editTask, setEditTask] = useState(false);
  const [replyWidth, setReplyWidth] = useState(0);
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const token = secureLocalStorage.getItem("auth_token");
  const [ticketDetails, setTicketDetails] = useState({});
  const [projectId, setProjectId] = useState([]);
  const [filterProject, setFilterProject] = useState(false);

  const [viewTaskHistory, setViewTaskHistory] = useState(false);
  const [timingLog, setTimingLog] = useState([]);
  const [taskId, setTaskId] = useState("");
  const [addHours, setAddHours] = useState(false);
  const [startTimer, setStartTimer] = useState("");
  const [endTimer, setEndTimer] = useState("");
  const [reason, setReason] = useState([]);
  const [timerId, setTimerId] = useState([]);
  const [type, setType] = useState(false);

  const toggleLoading = (loading) => {
    setLoading(loading);
  };

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      if (replyTiket) {
        setReplyTiket(false);
      }
      if (viewTicketHistory) {
        setViewTicketHistory(false);
      }
      if (editTask) {
        setEditTask(false);
      }
    }
  });

  document.title = "Support | Zithas Technologies";
  const [isLoading, setLoading] = useState(false);
  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth;
      setReplyWidth(viewportWidth * 0.98);
    };
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  const [modal_Access, setAccessDenied] = useState(false);
  const [ticketStatus, setTicketStatus] = useState("all");
  const onReply = (obj) => {
    setTicketDetails(obj);
    setReplyTiket(true);
  };

  const onChangeStatus = async (value, id) => {
    const formEntries = {
      ticket_id: id,
      user_id: localStorage.getItem("auth_id"),
      status: value,
    };
    const res = await FetchPostData(
      toggleLoading,
      "changeTicketStatus",
      token,
      formEntries,
    );
    if (res?.data?.success) {
      Swal.fire({
        icon: "success",
        text: "Ticket Status Updated Successfully",
      }).then((data) => {
        if (ticketStatus == "all") {
          setData(res?.data?.data?.tickets);
        } else {
          setData(
            res?.data?.data?.tickets?.filter(
              (obj) => obj?.status == ticketStatus,
            ),
          );
        }
        setAllData(res?.data?.data?.tickets);
      });
    }
  };
  const { handleStartStop, isRunning, currentTaskId } = useTimer();
  // const onStartTimer = async (obj, isRunnings) => {
  //   const date = new Date();
  //   const formEntriesStart = {
  //     user_id: localStorage.getItem("auth_id"),
  //     task_id: obj?.id,
  //     type: 1,
  //   };
  //   const formEntiesStop = {
  //     id: localStorage.getItem("timerId"),
  //   };

  //   const res = await FetchNodePostData(
  //     toggleLoading,
  //     isRunnings ? "codeReviewTimer/stopTimer" : "codeReviewTimer/startTimer",
  //     token,
  //     isRunnings ? formEntiesStop : formEntriesStart
  //   );
  //   if (res?.data?.status) {
  //     if (!isRunnings) {
  //       localStorage.setItem("task_id", obj.id);
  //       localStorage.setItem("timerId", res?.data?.data?.id);
  //       localStorage.setItem("start_time", date.toISOString());
  //       localStorage.setItem("code_time", true);
  //     } else {
  //       localStorage.removeItem("task_id");
  //       localStorage.removeItem("timerId");
  //       localStorage.removeItem("start_time");
  //       localStorage.removeItem("code_time");
  //     }
  //     handleStartStop(obj.id);
  //   }
  // };

  const onStartTimer = async (obj) => {
    const date = new Date();
    const formEntriesStart = {
      user_id: localStorage.getItem("auth_id"),
      task_id: obj?.id,
      type: 1,
    };
    const formEntiesStop = {
      id: localStorage.getItem("timerId"),
    };

    const res = await FetchNodePostData(
      toggleLoading,
      isRunning ? "codeReviewTimer/stopTimer" : "codeReviewTimer/startTimer",
      token,
      isRunning ? formEntiesStop : formEntriesStart,
    );
    if (res?.data?.status) {
      if (!isRunning) {
        localStorage.setItem("task_id", obj.id);
        localStorage.setItem("timerId", res?.data?.data?.id);
        localStorage.setItem("start_time", date.toISOString());
        localStorage.setItem("isTicketTime", true);
      } else {
        localStorage.removeItem("isTicketTime");
      }
      handleStartStop(obj.id);
    }
  };

  const onAddHours = async (id) => {
    const res = await fetchNodeData(
      toggleLoading,
      `supportTimerDetails/${id}`,
      token,
    );
    if (res?.success) {
      console.log("timmings: ", timingLog);
      setViewTaskHistory(true);
      setTimingLog(res?.data);
      setTaskId(id);
    }
  };

  const columns1 = useMemo(
    () =>
      developerTicketColumn(
        onReply,
        onChangeStatus,
        onStartTimer,
        isRunning,
        currentTaskId,
        onAddHours,
      ),
    [ticketStatus, isRunning],
  );

  const fetchProjects = async () => {
    const userId = localStorage.getItem("auth_id");
    const res = await fetchData(
      toggleLoading,
      `ticketsData/${userId}/${projectId?.value}`,
      token,
    );
    if (res?.success) {
      setFilterProject(true);
      setData(res?.data?.tickets);
      setAllData(res?.data?.tickets);
    }
  };
  const onStatus = (status) => {
    setTicketStatus(status);
  };

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="row justify-content-between  align-items-center">
        <div className="col-md-3">
          <h5 className="text-purple mb-0 ms-3"> Support Tickets</h5>
        </div>
        <div className="col-md-8">
          <div className="row justify-content-end  align-items-center">
            <div className="col-md-5">
              <Select
                placeholder="Select Project"
                className="basic-multi-select"
                classNamePrefix=" select"
                options={projectOption}
                value={projectId}
                onChange={(e) => setProjectId(e)}
              />
            </div>
            <div className="ms-2 col-md-1">
              <a
                className="btn btn-sm  me-1 bg-purple text-white"
                style={{ borderRadius: "5px" }}
                onClick={() => fetchProjects()}
              >
                <i className="bi bi-funnel-fill fs-5"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      {filterProject ? (
        <Container fluid>
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns1}
                      data={data}
                      allData={allData}
                      setAccessDenied={setAccessDenied}
                      setData={setData}
                      onStatus={onStatus}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      ) : (
        <div className="d-flex flex-column align-items-center justify-content-center">
          <img src={NoTickets} alt="No Img" width={300} />
          <h5 className="text-purple fw-bold  lh-lg text-center">
            Filter the projects, tackle those tickets 📝, and let's keep the
            quality high! <br /> 🚀💪 Let’s deliver an outstanding product
            together! 💯✨
          </h5>
        </div>
      )}

      {/* Reply Ticket  */}
      <div className={`note-sticky-form ${replyTiket ? "d-block" : "d-none"}`}>
        <Draggable handle=".modal-header" cancel=".modal-body">
          <ResizableBox
            width={replyWidth}
            style={{
              position: "fixed",
              top: "5%",
              right: "0.5%",
              zIndex: "1055",
              backgroundColor: "#fff",
              maxHeight: "fit-content",
              transform: "translate(-50%, -50%)",
            }}
          >
            <div className="modal-header p-0 mb-3 border-0">
              <h5 className="modal-title mt-0 text-dark">
                Reply Ticket - {ticketDetails?.id}{" "}
              </h5>
              <span
                aria-hidden="true"
                className="btn-modal-span cursor-pointer"
                onClick={() => setReplyTiket(false)}
              >
                &times;
              </span>
            </div>

            <div className="modal-body  ps-0 overflow-hidden">
              <ReplyIndex
                ticketDetails={ticketDetails}
                replyTiket={replyTiket}
              />
            </div>
          </ResizableBox>
        </Draggable>
      </div>

      <Modal
        size="xl"
        isOpen={viewTaskHistory}
        centered
        toggle={() => {
          setViewTaskHistory(false);
        }}
      >
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">View Task History</h5>
          <div className="d-flex gap-2 align-items-center">
            <a className="d-flex gap-3 align-items-center general-box  ">
              <h5 className="text-purple mb-0">Total Time : </h5>
              <h5 className="text-primary mb-0">
                {calculateTotalTaskTime(timingLog)}
              </h5>
            </a>
            {/* <a
              className="btn btn-sm btn-primary me-1 d-flex align-items-center"
              onClick={() => {
                setType(true)
                setAddHours(!addHours)
                // setViewTaskHistory(false)
              }}
            >
              <i className="bx bx-plus fs-6"></i>
              {!addHours ? "Add" : "Close"}
            </a> */}
            <button
              type="button"
              onClick={() => {
                setViewTaskHistory(false);
                setAddHours(false);
                setStartTimer("");
                setEndTimer("");
                setReason([]);
              }}
              className="btn-modal-close"
            >
              <span aria-hidden="true" className="btn-modal-span">
                &times;
              </span>
            </button>
          </div>
        </div>

        <div className="modal-body pe-4 my-2">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-4 d-flex justify-content-end align-items-center ps-3">
              <div className="text-center">
                <img src={viewTaskImg} alt="Addepe" style={{ width: "80%" }} />
              </div>
            </div>
            <div className="col-md-8 viewPackage-box">
              {addHours ? (
                <div className="mb-4">
                  {endTimer && startTimer && (
                    <p className="fw-bold text-purple mb-0">
                      Total Time :{" "}
                      {calculateTimeDifference(startTimer, endTimer)}
                    </p>
                  )}
                  <form onSubmit={onChangeTimer}>
                    <div className="col-md-12 row align-items-center new-task-modal ">
                      <div className="col-md-6 mt-4 mb-3">
                        <label>Start Time</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          placeholder="Enter Time"
                          value={startTimer}
                          onChange={(e) => setStartTimer(e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-md-6 mt-4 mb-3">
                        <label>End Time</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          placeholder="Enter Time"
                          value={endTimer}
                          onChange={(e) => {
                            const newEndTime = e.target.value;

                            if (startTimer) {
                              const start = moment(startTimer);
                              const end = moment(newEndTime);

                              if (end.isBefore(start)) {
                                Swal.fire({
                                  icon: "warning",
                                  title: "Invalid Time",
                                  text: "End time cannot be earlier than start time",
                                  confirmButtonColor: "#556ee6",
                                });
                                return;
                              }
                            }

                            setEndTimer(newEndTime);
                          }}
                          required
                        />
                      </div>
                      <div className="row align-items-end mb-5">
                        <div className="col-md-10">
                          <label>Reasons</label>
                          <Select
                            placeholder="Select Time"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            options={resaonOtption?.filter(
                              (obj) => obj?.value != 6,
                            )}
                            value={reason}
                            onChange={(e) => setReason(e)}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                          />
                        </div>

                        <div className="col-md-1 d-flex align-items-end">
                          <button className="btn btn-save btn-label ">
                            <i className="fas fa-save me-2 label-icon"></i> Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              ) : null}
              <Table bordered hover responsive size="" striped>
                <thead>
                  <tr>
                    <th className="text-center task-col-1">ID</th>
                    <th className="task-col-2 text-center">Start Time</th>
                    <th className="task-col-3 text-center">End Time</th>
                    <th className="task-col-3 text-center">Cal. Time</th>
                    {/* <th className="task-col-2 text-center">Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {timingLog?.map((obj, i) => {
                    const currentTime = new Date();
                    return (
                      <tr key={i}>
                        <td scope="row" className="text-center task-col-1">
                          {i + 1}
                        </td>
                        <td className="task-col-2 text-center">
                          {moment
                            .utc(obj?.start_time)
                            ?.format("DD-MM-YYYY hh:mm:ss a")}{" "}
                        </td>
                        <td className="task-col-2 text-center">
                          {obj?.end_time != null
                            ? moment
                                .utc(obj?.end_time)
                                ?.format("DD-MM-YYYY hh:mm:ss a")
                            : "-"}
                        </td>
                        <td className="text-center">
                          {calculateTimeDifference(
                            obj?.start_time,
                            obj?.end_time != null ? obj?.end_time : currentTime,
                          )}
                        </td>
                        {/* <td className="task-col-4 text-center">
                          <a
                            className="btn btn-sm btn-outline-primary me-1"
                            onClick={() => {
                              setAddHours(true)
                              // setViewTaskHistory(false)
                              setTimerId(obj?.id)
                              setStartTimer(obj?.start_time)
                              setEndTimer(obj?.end_time)
                            }}
                          >
                            <i className="bx bx-pen fs-6"></i>
                          </a>
                        </td> */}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </Modal>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  );
};

export default DeveloperTickets;
